// Timestamps from the server come from SQLite CURRENT_TIMESTAMP: UTC, written as
// "YYYY-MM-DD HH:MM:SS" without a zone. `new Date()` reads that as local time, so
// everything looked 1–2 hours old in the Netherlands. This reads that exact form as
// UTC (built as ISO with "Z", which Safari also parses).
//
// Everything else keeps the old behaviour: wall-clock times of events and meetings
// ("YYYY-MM-DDTHH:mm", no seconds, no space) are meant as local time, date-only
// values are dates, and ISO strings with a zone already say what they are.
const SERVER_TIMESTAMP = /^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2})(\.\d+)?$/;

export function parseServerDate(value) {
  if (value instanceof Date) return value;
  if (typeof value === 'string') {
    const m = SERVER_TIMESTAMP.exec(value.trim());
    if (m) return new Date(`${m[1]}T${m[2]}${m[3] || ''}Z`);
  }
  return new Date(value);
}
